<template>
	<form
		:class="[
			'styled-form',
			'styled-form--white-box',
			{'is-loading': isLoading}
		]"
		@submit.prevent="onSubmit"
	>

		<div v-if="isLoading" class="styled-form__overlay">
			<div class="preloader"></div>
		</div>

		<global-message v-if="errors.global" :value="errors.global"></global-message>

		<div class="styled-form__header">
			<h2 class="styled-form__title">Please verify your email address</h2>

			<h3 class="styled-form__subtitle" v-if="!showEmail">We have sent an email to <span class="styled-form__highlighted">{{ data.email }}</span>, please copy the code in the email and paste into the field below</h3>
			<h3 class="styled-form__subtitle" v-else>We have sent you an email, please copy the code in the email and paste into the field below</h3>
		</div>

		<div class="styled-form__field styled-form__field--centered" v-if="!showEmail">
			<span
				:class="['styled-form__error', {'is-visible': errors.code}]"
			>{{ errors.code }}</span>

			<input
				v-model="data.code"
				:class="['styled-form__input', {'is-invalid': errors.code}]"
				name="code"
				:style="{
					width: '230px'
				}"
        :max="10000"
			>
		</div>

		<div class="styled-form__corset" v-else>

			<form-input
				v-model="data.email"
				name="email"
				label="Email Address *"
				:error="errors.email"
				class="to-lower-case"
			></form-input>

			<form-input
				v-model="data.code"
				name="code"
				type="number"
				label="Code *"
				:error="errors.code"
			></form-input>

		</div>

		<div class="styled-form__v-rhythm text--center">
			<button class="btn" :disabled="isLoading">Continue</button>
		</div>

		<div class="styled-form__corset" v-if="sendAgain">
			<div class="styled-form__info styled-form__info--bg text--center">
				Haven’t received the email?
				<a
					class="styled-form__link styled-form__link--lowercase"
					:disabled="isLoading"
					@click.prevent="sendAgain"
				>Send again</a>
			</div>
		</div>



	</form>
</template>

<style>
	.styled-form__header {
		margin-bottom: 20px;
	}

</style>

<script>
	import { mapState } from 'vuex';
	import GlobalMessage from '../messages/GlobalMessage.vue';
    import isEmail from '../../helpers/isEmail';
    import FormInput from '../formFields/FormInput.vue';

	export default {
		components: {
			FormInput,
			GlobalMessage
		},
		props: {
			submit: {
				type: Function,
				required: true
			},
			sendAgain: {
				type: Function
			},
			email: String,
			code: String
		},
		data() {
			return {
				isLoading: false,
				data: {
					email: '',
					code: ''
				},
				errors: {},
				showEmail: true
			}
		},
		created() {
			this.validateProps();

			if (this.data.email && this.data.code) {
				this.onSubmit();
			}
		},
		methods: {
			validateProps() {
				if (isEmail(this.email)) {
					let emailProp = this.email;
					this.data.email = emailProp.toLowerCase();

					this.showEmail = false;
				}

				if (this.code && /^\d+$/.test(this.code)) {
					this.data.code = this.code;
				}
			},
			onSubmit() {
				this.errors = this.validate(this.data);

				if (!this.isLoading && Object.keys(this.errors).length === 0) {
                    this.data.email = this.data.email.toLowerCase();
					this.isLoading = true;
					this.submit(this.data).catch(errors => {
                        if (errors.global == 'User cannot confirm because user status is not UNCONFIRMED.') {
                            // redirect to the simplified login page
                            this.$router.push({
                                name: 'login',
                                params: {
                                    form: 'simplified',
                                    email: this.data.email.toLowerCase()
                                }
                            });
                        } else {
                            this.isLoading = false;
                            this.errors = errors;

                            if (errors instanceof Error) {
                                // console.error(errors);
                            }
                        };
					});
				}
			},
			validate(data) {
				const errors = {};

				if (!data.email.length) {
					errors.email = 'This field is required';
				} else if (!isEmail(data.email)) {
					errors.email = 'Invalid email';
				}

				if (!data.code.length) {
					errors.code = 'This field is required';
				} else if (!(/^\d+$/.test(data.code))) {
					errors.code = 'This field can only contain numeric values';
				}

				return errors;
			}
		}
	};
</script>
